import { FC } from "react";
import { IonButtons } from "@ionic/react";
import { AllieButtonsProps } from "./Buttons.types";

export const AllieButtons: FC<AllieButtonsProps> = (props) => <IonButtons {...props} />;
